import { JavelinaBaseClient } from './JavelinaBaseClient'

export class JavelinaAuthClient extends JavelinaBaseClient {
    constructor(
        javelinaProxyApiUrl = process.env.JAVELINA_PROXY_API_URL, 
        javelinaProxySecretName = process.env.JAVELINA_PROXY_SECRET_NAME || '',
        axiosOptions
    ) {
        super(javelinaProxyApiUrl, javelinaProxySecretName, axiosOptions)
    }

    /**
     * @description description
     */
    async createAuth (referral, txnId) {
        await this.createSecureAxiosInstance({
            'X-Transaction-ID': txnId
        });

        const body = {
            "CreateAuthorization": {
                "EmpDepAuthorization": {
                    ...referral
                }
            }
        }

        const response = await this.secureAxiosInstance.post(`pureProxy/core/createAuthorizations`, body);

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    }

    /**
     * @description returns all authorizations for an employee through JV.
     */
    async getEmployeeAuthorizationsByEmployeeId (employeeId) {
        await this.createSecureAxiosInstance();

        const params = {
            EmployeeID: employeeId
        }

        let path = this.queryParamsToPathParams(params, `pureProxy/core/listAuthorizations`);

        const response = await this.secureAxiosInstance.get(path);

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    }

    /**
     * @description returns authorization details by employee ID and authorization number
     */
    async getEmployeeAuthorizationsByEmployeeIdAndAuthorizationNumber (employeeId, authorizationNumber) {
        await this.createSecureAxiosInstance();
        
        const params = {
            EmployeeID: employeeId,
            AuthorizationNumber: authorizationNumber
        }

        let path = this.queryParamsToPathParams(params, `pureProxy/core/readAuthorizations`);

        const response = await this.secureAxiosInstance.get(path);

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    }

    /**
     * @description description
     */
    async updateAuthorizationSpecialty(referral, member, specialtyCode, txnId) {
        await this.createSecureAxiosInstance({
            'X-Transaction-ID': txnId
        });

        const body = {
            "UpdateAuthorization": {
                "EmpDepAuthorization": {
                    "EmployeeID": member.EmployeeID,
                    "DepSequenceNumber": member.DepSequenceNumber,
                    "AuthorizationType": referral.AuthorizationType,
                    "AuthorizationNumber": referral.AuthorizationNumber,
                    "ProviderRule": referral.ProviderRule,
                    "ProviderSpecialty": specialtyCode,
                    "AuthorizedTotals": {
                        "AuthActions": referral.AuthActions, //EE
                        "EmpDepAuthCategory": [
                            {
                                "AuthorizationCategory": referral.AuthorizationCategory //AUTH-See Services
                            }
                        ]
                    }
                }
            }
        }

        const response = await this.secureAxiosInstance.put(`pureProxy/core/updateAuthorizations`, body);

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    }
}
